"use strict";

var _require = require('../constants/regexp'),
    YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY = _require.YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY;

var REGEXP_YEAR_MONTH_DAY_PREFIX = new RegExp("^" + YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY + "/");

var replaceAllButLastSlashes = function replaceAllButLastSlashes(slug) {
  return "" + slug.slice(0, -1).replace(/\//g, '-') + slug.substr(-1);
};

var replaceAllSlashesRemoveLast = function replaceAllSlashesRemoveLast(slug) {
  return "" + replaceAllButLastSlashes(slug).replace(/\/$/, '');
};

var allowYearMonthDayPrefix = function allowYearMonthDayPrefix(slug, _ref) {
  var _ref$field = _ref.field,
      field = _ref$field === void 0 ? '' : _ref$field;

  var _ref2 = field.match(REGEXP_YEAR_MONTH_DAY_PREFIX) || [],
      year = _ref2[1],
      month = _ref2[2],
      day = _ref2[3];

  var addTrailingSlash = field.substr(-1) === '/' && slug.substr(-1) !== '/';

  if (!year) {
    return replaceAllButLastSlashes(slug);
  }

  var prefix = day ? year + "/" + month + day + "/" : year + "/" + month + "/";
  return "" + prefix + replaceAllButLastSlashes(slug.slice(prefix.length)) + (addTrailingSlash ? '/' : '');
};

module.exports = {
  replaceAllSlashesRemoveLast: replaceAllSlashesRemoveLast,
  allowYearMonthDayPrefix: allowYearMonthDayPrefix
};